export default "__VITE_ASSET__CMLc1nGN__"